<div class="m-portlet">
	<div class="m-portlet__head">
		<div class="m-portlet__head-progress">
			<!-- here can place a progress bar-->
			<mat-progress-bar mode="indeterminate" *ngIf="viewLoading"></mat-progress-bar>
		</div>
		<div class="m-portlet__head-caption">
			<div class="m-portlet__head-title">
				<span class="m-portlet__head-icon m--hide">
					<i class="la la-gear"></i>
				</span>
				<h3 class="m-portlet__head-text">
					{{data.title}}
				</h3>
			</div>
		</div>
	</div>
	<div class="m-form">
		<div class="m-portlet__body">
			<div class="form-group m-form__group row">
				<div class="col-lg-12">
					{{ viewLoading ? data.waitDesciption : data.description}}
				</div>
			</div>
		</div>
		<div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit text-right">
			<div class="m-form__actions m-form__actions--sm">
				<button mat-raised-button (click)="onYesClick()" color="primary" cdkFocusInitial
					[disabled]="viewLoading">EVET</button>&nbsp;
				<button mat-raised-button color="warn" (click)="onNoClick()">HAYIR</button>&nbsp;
			</div>
		</div>
	</div>
</div>